import axios from "axios";

export const listClinics = async () => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/clinic/list`, {
      withCredentials: true,
    })
    .then((response) => response.data);
};

export const listClinicQuery = async (
  page: string,
  perPage: string,
  search: string
) => {
  return axios
    .get(
      `${process.env.REACT_APP_API_URL}/clinic/list-query?page=${page}&perPage=${perPage}&search=${search}`,
      {
        withCredentials: true,
      }
    )
    .then((response) => response.data);
};
